<c3-config-section-box
  [title]="TP_SECTIONS_INFO['therapies'].label"
  [icon]="TP_SECTIONS_INFO['therapies'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["therapies"].description }}</p>

  <div [c3ConfigForm]="this" [c3ConfigFormHideSaveBtn]="true">
    <ion-toolbar>
      <ion-buttons slot="start" class="c3-flex-wrap ion-justify-content-start">
        <div class="c3-flex ion-align-items-center ion-margin-start">
          <ion-checkbox
            (ionChange)="toggleShowEnded($event.detail.checked)"
            class="ion-margin-end"
            color="secondary"
          >
          </ion-checkbox>
          <ion-label>Mostra terminati</ion-label>
        </div>
      </ion-buttons>

      <ion-buttons slot="end" class="c3-flex-wrap ion-justify-content-end">
        <ion-button (click)="onRefreshList()" c3Tooltip="Ricarica lista">
          <ion-icon slot="icon-only" [src]="'refresh' | getIcon"></ion-icon>
        </ion-button>

        <ion-button
          color="secondary"
          (click)="openEditDialog({ insulinTherapy: true })"
          *ngIf="isDiabetesContext"
          fill="solid"
        >
          <span class="ion-hide-md-down">Aggiungi Terapia Insulinica</span>
          <ion-icon slot="end" [src]="'needle' | getIcon"></ion-icon>
        </ion-button>

        <ion-button
          color="secondary"
          (click)="openEditDialog({ oncoTherapy: true })"
          *ngIf="context.includes(CTX_ONCOLOGY) || context.includes(CTX_ONCOLOGY_BREAST_CANCER)"
          fill="solid"
        >
          <span class="ion-hide-md-down">Aggiungi Terapia "Capecitabina"</span>
          <ion-icon slot="end" [src]="'ribbon' | getIcon"></ion-icon>
        </ion-button>

        <ion-button (click)="openEditDialog({})" fill="solid" color="primary">
          <span class="ion-hide-md-down">
            <span>Aggiungi </span>
            <span
              *ngIf="
                isDiabetesContext ||
                context.includes(CTX_ONCOLOGY) ||
                context.includes(CTX_ONCOLOGY_BREAST_CANCER)
              "
            >
              Altra
            </span>
            <span>Terapia</span>
          </span>
          <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <ion-grid *ngIf="(therapies$ | async)?.length === 0">
      <ion-row class="ion-justify-content-center">
        <ion-col size="auto">
          <app-hint-msg type="custom-icon" customIcon="help-circle-outline" size="large">
            <span>
              Non sono presenti terapie. Inizia ad aggiungerle utilizzando i bottoni sopra la
              tabella in alto a destra
            </span>
          </app-hint-msg>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div *ngIf="viewType === 'table'">
      <app-hint-msg size="small">
        <span
          >Cliccando sul titolo di una colonna è possibile ordinare i dati secondo la colonna
          scelta</span
        >
      </app-hint-msg>

      <app-hint-msg size="small">
        <span>
          Avvicinandosi con il mouse ai bordi dell'intestazione di una colonna è possibile aumentare
          o ridurre le dimensioni della colonna
        </span>
      </app-hint-msg>

      <ag-grid-angular
        c3DarkTable
        class="ag-theme-material c3-table-with-clickable-rows"
        [modules]="agModules"
        [rowData]="therapies$ | async"
        [columnDefs]="columnDefs"
        [gridOptions]="agGridOptions"
      >
      </ag-grid-angular>
    </div>

    <div *ngIf="viewType === 'chart'">
      <c3-therapies-chart
        [timeRange]="viewPeriod"
        [diary]="diaryTherapies"
        [hideAssumptions]="true"
      >
      </c3-therapies-chart>
    </div>
  </div>
</c3-config-section-box>

<ng-template #insulinCellTmpl let-cell>
  <ng-container *ngIf="cell?.data.data.drug.active_ingredient?.toLowerCase().includes('insulin')">
    <ion-icon
      size="small"
      [src]="'needle' | getIcon"
      c3Tooltip="Questa è una terapia insulinica"
    ></ion-icon>
  </ng-container>
  <ng-container *ngIf="!cell?.data.data.drug.active_ingredient?.toLowerCase().includes('insulin')">
    <ion-icon size="small" [src]="'minus' | getIcon"></ion-icon>
  </ng-container>
</ng-template>

<ng-template #assumptionsCellTmpl let-cell>
  <span *ngIf="cell?.data.data.variable.assumptions?.length > 0"> Variabili </span>

  <ng-container
    *ngIf="
      cell?.data.data.variable.assumptions?.length === 0 &&
      cell?.data.data.regular.frequency.type !== 'at_need'
    "
  >
    <div *ngFor="let a of cell?.data.data.regular.assumptions">
      <span>
        {{ a.quantity }} {{ a.unit | clinicalDataTranslation: ClinicalDataType.ASSUMPTION }},
        {{ a.moment | clinicalDataTranslation: ClinicalDataType.ASSUMPTION }} ({{ a.time }})
      </span>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      cell?.data.data.variable.assumptions?.length === 0 &&
      cell?.data.data.regular.frequency.type === 'at_need'
    "
  >
    <div *ngFor="let a of cell?.data.data.regular.assumptions">
      <span>
        {{ a.quantity }} {{ a.unit | clinicalDataTranslation: ClinicalDataType.ASSUMPTION }}
        {{ a.moment | clinicalDataTranslation: ClinicalDataType.ASSUMPTION }}
      </span>
    </div>
  </ng-container>
</ng-template>

<ng-template #actionsCellTmpl let-cell>
  <ion-buttons>
    <ion-button
      (click)="openEditDialog({ therapy: cell?.data }, $event)"
      c3Tooltip="Apri o Modifica"
    >
      <ion-icon slot="icon-only" color="primary" [src]="'pencil' | getIcon"></ion-icon>
    </ion-button>

    <ng-container
      *ngIf="cell?.data.data.state === 'active' && cell?.data.metadata.end_date > getCurrentDate()"
    >
      <ion-button
        (click)="openEnableInterruptDialog(cell?.data, 'suspend', $event)"
        c3Tooltip="Sospendi"
      >
        <ion-icon
          slot="icon-only"
          color="warning"
          [src]="'pause-circle-outline' | getIcon"
        ></ion-icon>
      </ion-button>

      <ion-button
        *ngIf="cell?.data.metadata.end_date > getCurrentDate()"
        (click)="openEnableInterruptDialog(cell?.data, 'interrupt', $event)"
        c3Tooltip="Interrompi"
      >
        <ion-icon
          slot="icon-only"
          color="danger"
          [src]="'stop-circle-outline' | getIcon"
        ></ion-icon>
      </ion-button>
    </ng-container>

    <ng-container
      *ngIf="
        cell?.data.data.state === 'inactive' && cell?.data.metadata.end_date > getCurrentDate()
      "
    >
      <ion-button
        (click)="openEnableInterruptDialog(cell?.data, 'resume', $event)"
        c3Tooltip="Riprendi"
      >
        <ion-icon
          slot="icon-only"
          color="success"
          [src]="'play-circle-outline' | getIcon"
        ></ion-icon>
      </ion-button>
    </ng-container>
  </ion-buttons>
</ng-template>
